<template>
  <c-volume
    v-if="this.params.value"
    :class="paddingClass"
    :volume="{
      value: this.params.value,
      pct: (100 / this.params.context[`max${this._.capitalize(this.params.valueType)}Size`]) * this.params.value,
      direction: this.params.direction,
      barColor: barColor
    }"
  ></c-volume>
</template>

<script>
import CVolume from '@custom/CVolume';
import { hexToRGBA } from '@/utils/colors';

export default {
  components: { CVolume },
  computed: {
    paddingClass() {
      return this.params.direction === 'rightJustified' ? 'pr-2' : 'pl-2';
    },
    barColor() {
      return hexToRGBA(this.params.marketDepthRowColors[`--color-${this.params.rowIndex}-text`], 0.3);
    }
  }
};
</script>
